import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {Spin, Table, Tag, Modal, message} from 'antd'
import restoreForm from '../FormDetail/save/restoreForm'
import FormArchives from '../DAL/FormArchives'
import Forms from '../DAL/Forms'
import { query, where, orderBy, getDocs, doc, updateDoc, increment } from 'firebase/firestore'
import { db } from '../utilities'

export default function VersionsList({match}) {
  const {formId} = match.params
  const [archives, setArchives] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const formArchives = new FormArchives()
    getDocs(query(formArchives.baseQuery, where('formId', '==', formId), orderBy('archivedAt', 'desc')))
      .then((snap) => {
        setArchives(snap.docs.map((d) => ({id: d.id, ...d.data()})))
        setLoading(false)
      })
      .catch((e) => {
        console.error('Failed to load archives', e)
        setLoading(false)
      })
  }, [formId])

  function handleDelete(record) {
    Modal.confirm({
      title: 'Delete this version?',
      content: `Archived on ${record.archivedAt ? record.archivedAt.toDate().toLocaleString() : 'N/A'} by ${record.archivedBy?.name || 'Unknown'}. This cannot be undone.`,
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          const formArchives = new FormArchives()
          await formArchives.delete(record.id)
          await updateDoc(doc(new Forms().baseQuery, formId), {
            archiveCount: increment(-1),
          })
          setArchives((prev) => prev.filter((a) => a.id !== record.id))
          message.success('Version deleted')
        } catch (err) {
          console.error(err)
          message.error('Failed to delete version')
        }
      },
    })
  }

  function handleRestore(record) {
    Modal.confirm({
      title: 'Restore this version?',
      content: `Archived on ${record.archivedAt ? record.archivedAt.toDate().toLocaleString() : 'N/A'} by ${record.archivedBy?.name || 'Unknown'}. This will overwrite the current form.`,
      okText: 'Restore',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          await restoreForm(formId, record.id)
          message.success('Form restored successfully')
        } catch (err) {
          console.error(err)
          message.error('Failed to restore form')
        }
      },
    })
  }

  const columns = [
    {
      title: 'Archived On',
      key: 'archivedAt',
      render: (_text, record) =>
        record.archivedAt ? record.archivedAt.toDate().toLocaleString() : 'N/A',
    },
    {
      title: 'Archived By',
      key: 'archivedBy',
      render: (_text, record) => (record.archivedBy ? record.archivedBy.name : 'Unknown'),
    },
    {
      title: 'Form Title (at time of archive)',
      key: 'title',
      dataIndex: 'title',
    },
    {
      title: '',
      key: 'open',
      render: (_text, record) => (
        <span>
          <Link to={`/formarchive/${record.id}`}>Open</Link>
          <span style={{margin: '0 8px', color: '#ccc'}}>|</span>
          <Link to={`/rubricsarchive/${record.id}`}>Rubrics</Link>
          <span style={{margin: '0 8px', color: '#ccc'}}>|</span>
          <a onClick={() => handleRestore(record)} style={{cursor: 'pointer'}}>Restore</a>
          <span style={{margin: '0 8px', color: '#ccc'}}>|</span>
          <a onClick={() => handleDelete(record)} style={{cursor: 'pointer', color: '#ff4d4f'}}>Delete</a>
        </span>
      ),
    },
  ]

  return (
    <div style={{padding: '2rem'}}>
      <div style={{marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem'}}>
        <Link to={`/forms/${formId}`}>← Back to Form</Link>
        <h2 style={{margin: 0}}>Version History</h2>
        <Tag color="orange">Read-Only</Tag>
      </div>
      {loading ? (
        <Spin />
      ) : (
        <Table
          dataSource={archives}
          columns={columns}
          rowKey="id"
          pagination={false}
          locale={{emptyText: 'No archived versions yet.'}}
        />
      )}
    </div>
  )
}
